import IgvViewer from './igv/IgvViewer'
import type { ViewerId, ViewerRegistryEntry } from './types'

export const viewerRegistry: Record<ViewerId, ViewerRegistryEntry> = {
  igv: {
    id: 'igv',
    label: 'IGV.js',
    description: 'Integrative Genomics Viewer (igv.js) for VCF tracks.',
    component: IgvViewer,
  },
}

export const viewerList: ViewerRegistryEntry[] = Object.values(viewerRegistry)

export function getViewer(id: string): ViewerRegistryEntry | undefined {
  return (viewerRegistry as Record<string, ViewerRegistryEntry>)[id]
}
